import React from 'react';
import './Success.css';

function Success() {

  return (
    <div className="success-container">
      <div className="success-content">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#4CAF50" />
            <path d="m9 12 2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1>¡Pago Exitoso!</h1>
        <p className="success-message">
          Gracias por tu increíble regalo. Tu pago ha sido procesado exitosamente.
        </p>



        <div className="next-steps">
          <h3>¿Qué sigue?</h3>
          <ul>
            <li>Recibirás un correo de agradecimiento con los detalles de tu regalo</li>
            <li>El regalo será marcado como adquirido en nuestra lista</li>
            <li>¡Nos vemos en la boda!</li>
          </ul>
        </div>

        <div className="action-buttons">
          <button
            className="btn-primary"
            onClick={() => window.location.href = '/regalos'}
          >
            Volver a la Mesa de Regalos
          </button>
          <button
            className="btn-secondary"
            onClick={() => window.location.href = '/'}
          >
            Ir al Inicio
          </button>
        </div>
      </div>
    </div>
  );
}

export default Success;
